import { TablePrintResumidoComponent } from "../../../../components";
import { format } from "date-fns";
import { formatDate, formatPrice } from "../../../../utils";
import FooterTotalizadoresContadorCfop from "./components/footer-totalizadores-contador-cfop/footer-totalizadores-contador-cfop.component";

const PrintNfSaidaResumidoContador = ({
  filtrosAplicadosImpressao,
  relatoriosTotais,
  tituloRelatorio,
  print,
}) => {
  const columns = [
    {
      header: "Serie",
      field: "serieDocumento",
    },
    {
      header: "Nº Doc.",
      field: "numeroDocumento",
    },
    {
      header: "Data Emissão",
      field: "dataEmissao",
      render: ({ dataEmissao }) =>
        format(formatDate.received(dataEmissao), "dd/MM/yyyy"),
    },
    {
      header: "Modelo Doc.",
      field: "modeloDocumento",
      align: "center",
    },
    {
      header: "Chave Acesso",
      field: "chaveAcesso",
      render: ({ chaveAcesso }) =>
        chaveAcesso ? chaveAcesso.replace(/\D/g, "") : "",
      width: "35%",
    },
    {
      header: "Nº Protoc.",
      field: "numProtocolo",
      render: ({ numProtocolo }) =>
        numProtocolo ? numProtocolo.replace(/\D/g, "") : "",
    },
    {
      header: "Total",
      field: "valorTotal",
      fieldTotal: "total",
      align: "end",
      render: ({ valorTotal }) => formatPrice(valorTotal, false),
    },
  ];
  return (
    <TablePrintResumidoComponent
      filtrosAplicadosImpressao={filtrosAplicadosImpressao}
      relatoriosTotais={relatoriosTotais.nfSaida}
      totais={relatoriosTotais.totais}
      tituloRelatorio={tituloRelatorio}
      print={print}
      columns={columns}
      itensPorPagina={31}
      footerTotalizador={
        <FooterTotalizadoresContadorCfop
          totalizadores={relatoriosTotais.totalizadores}
        />
      }
    />
  );
};

export default PrintNfSaidaResumidoContador;
